import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/error.css';

class Error404 extends Component {
    goBackBtn = () => {
        this.props.history.goBack();
    }
    render() {
        console.log(this.props);
        return (
            <div className='errorpage'>
                <div className="error-cont dark-blue-bg">
                    <div className="card error-card">
                        <div className="card-body text-center">
                            <p className='bold'>Page not Found</p>
                            <p className='block-heading'>404</p>
                            <hr />
                            <p>The page you are looking for is not found. Try going back to the previous
                                page or see our <Link  to='/help' className='bold black-text'>Help</Link> page for information
                            </p>
                            <hr />
                            <button onClick={this.goBackBtn} className="light-blue-button-sm">Go Back</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Error404;